// extracted by mini-css-extract-plugin
module.exports = {"ConsultantPages":"ConsultantPages_ConsultantPages__-fQDV"};